import tripEvents from './../config/events.constant';

import template from './templates/infantTraveller.tmpl.html';
import templateTripDetails from './templates/tripDetails/infantTraveller.tmpl.html';

export default function InfantTraveller(
    $rootScope,
    tripFactory,
    travellerUtils,
    userService,
    l10nService
) {
    'ngInject';

    return {
        restrict: 'A',
        template: function(el, attr) {
            return attr.template ? templateTripDetails : template;
        },
        scope: {
            infant: '=',
            model: '=',
            index: '=',
            lists: '=',
            isLocked: '=',
            isDisable: '=',
            isCancelled: '=',
            wasConfirmed: '=',
        },
        controller: ['$scope', function($scope) {
            $scope.regionalSettings = userService.getRegionalSettings();
        }],
        link: function(scope) {
            scope.l10n = l10nService;
            scope.editedInfant = angular.copy(scope.infant);
            scope.editedInfant.birthDayOpen = false;
            scope.editedInfant.expireDateOpen = false;
            scope.getToggleDropDown = function(dropdownKey = 'birthDayOpen') {
                scope.editedInfant[dropdownKey] = false;
            };

            const emptyInfant = travellerUtils.processTraveller({
                    Id: scope.infant.Id,
                    PassengerType: 'Infant',
                    HasMultiplePassports: false,
                },
                scope.model.Travelers,
                scope.infant.positionIndex);

            [tripEvents.TRIP_ADULT_SAVED, tripEvents.TRIP_INFANT_SAVED].forEach(
                function(event) {
                    scope.$on(event, function() {
                        prepareAdultAssignment();
                    });
                }
            );
            prepareAdultAssignment();

            scope.isActive = scope.model.IsEditable;

            scope.isFlightPresent = scope.model.IsFlightTripItemExist;

            scope.passportExpireDatepickerOptions = {
                min: moment(scope.model.TripLastDate).add({months: 6}),
            };

            scope.dateOfBirthDatepickerOptions = {
                min: moment(scope.model.MaximumInfantDob).add({days: 1}),
                max: moment(),
            };

            scope.collapseTravellerForm = function(traveller) {
                traveller.isOpenedForm = !traveller.isOpenedForm;
            };

            scope.getFullName = travellerUtils.getTravellerFullName;

            scope.getTravellerById = function(adultId) {
                return travellerUtils.getTravellerById(scope.model.Travelers.Adult, adultId);
            };

            scope.isAdultsCompleted = function() {
                if ($rootScope.readOnlyMode) {
                    return false;
                }

                return _.every(scope.model.Travelers.Adult, function(adult) {
                    return adult.IsCompleted;
                });
            };

            travellerUtils.addTravellerAdditionalFields(scope.editedInfant, scope.model.Travelers);

            scope.saveInfantTraveller = function(infant, editedInfant) {
                scope.isDuplicateError = !!travellerUtils.findTravellerNameDuplication(editedInfant, scope.model.Travelers);

                if (scope.isDuplicateError) {
                    return;
                }

                saveTraveller();

                function saveTraveller() {
                    if (!editedInfant.TripPassengerId) {
                        editedInfant.TripPassengerId = editedInfant.Id;
                    }

                    travellerUtils.saveTraveller(editedInfant, scope.model.Id, scope.isFlightPresent, null, infant.positionIndex)

                        .then((response) => {
                            editedInfant.TripPassengerId = editedInfant.Id = response.data.TripPassengerId;
                            _.extend(infant, editedInfant, {
                                AdultTripPassengerId: editedInfant.AdultTripPassengerId.value,
                                IsCompleted: true,
                                isOpenedForm: false,
                            }, function(value, other) {
                                if (other === '') {
                                    return null;
                                }
                                if (_.isObject(other)) {
                                    return angular.copy(other);
                                }
                                return other;
                            });

                            /**
                             * Update Trip details after Travellers adding
                             */
                            scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
                            $rootScope.$broadcast(tripEvents.TRIP_INFANT_SAVED);
                        })
                        .catch(() => {
                            infant.IsCompleted = false;
                        });
                }
            };
            scope.restoreData = function(restoreFormState) {
                if (restoreFormState) {
                    angular.copy(scope.infant, scope.editedInfant);
                } else {
                    angular.copy(emptyInfant, scope.editedInfant);
                }
                prepareAdultAssignment();
                scope.infant.isOpenedForm = !restoreFormState;
            };

            scope.ApisHasLevel = function(level) {
                return tripFactory.apisHasLevel(level, scope.model.ApisTsaSettings);
            };

            function prepareAdultAssignment() {
                scope.adultsForInfants = _.map(scope.model.Travelers.Adult, function(adult) {
                    return {
                        text: travellerUtils.getTravellerFullName(adult),
                        value: adult.Id || adult.TripPassengerId,
                    };
                });

                /**
                 * Set assigned Adults for Infants by AdultTripPassengerId
                 */
                scope.editedInfant.AdultTripPassengerId = scope.infant.AdultTripPassengerId
                    ? _.find(scope.adultsForInfants, function(adult) {
                    return (adult.value === scope.infant.AdultTripPassengerId);
                })
                    : {text: l10nService.localize('Select adult traveller'), value: 0};

                /**
                 * Set alone Adult for Infant
                 */
                scope.editedInfant.AdultTripPassengerId = (scope.adultsForInfants.length === 1)
                    ? scope.adultsForInfants[0]
                    : scope.editedInfant.AdultTripPassengerId;

                scope.editedInfant.AdultTripPassengerId = angular.copy(scope.editedInfant.AdultTripPassengerId);

                /**
                 * Get unassigned Adults
                 * Return all unassigned or assigned to this infant
                 */
                scope.adultsForInfants = _.filter(scope.adultsForInfants, function(adult) {
                    return adult.value === scope.infant.AdultTripPassengerId
                        || _.every(scope.model.Travelers.Infant, function(infant) {
                            return infant.AdultTripPassengerId !== adult.value;
                        });
                });
            }

            scope.isIconDisabled = function() {
                return !scope.isAdultsCompleted() || !travellerUtils.isEditIconEnabled(
                    scope.isLocked,
                    scope.isDisable,
                    scope.isCancelled,
                    scope.model
                );
            };
            scope.handleEditClick = function(infant) {
                if (!scope.isIconDisabled()) {
                    return scope.collapseTravellerForm(infant);
                }
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/infantTraveller.directive.js